import { Artist } from '../types/content';
import { images } from './images';

export const artists: Artist[] = [
  {
    slug: 'rick-trip',
    name: 'Rick Trip',
    image: images.rick,
    roles: ['Owner', 'Lead Tattoo Artist'],
    bio: [
      'Meet Rick Trip, our owner and lead tattoo artist at Trip Ink Tattoo Company. In addition to that he’s known as being one of the most talented tattoo artists in Las Vegas. With that said he is also widely known in the tattoo/art/music/film industry.',
      'Check out his quote below, as well as some of his past tattoos posted, and be sure to check out his most recent work on his Instagram @ricktrip.',
    ],
    quote:
      'I just use true techniques from tattooing. Bold will hold and I make sure that my color blends make sense with the skin tone I’m working with. My goal is to make my clients stand out in a room from people that are already tattooed. Its very popular to get tattooed now, but its not popular to think it out and try to stand out in the way that I’m doing it.',
    instagram: 'ricktrip',
  },
  {
    slug: 'sophia',
    name: 'Sophia Mae',
    image: images.sophia,
    roles: ['Tattoo Artist', 'Resident Piercer'],
    bio: [
      'We’d like to introduce the very talented Sophia Mae! She’s an accomplished tattoo artist, as you can see from her portfolio. And she’s also our Resident Piercer.',
      'So check out her portfolio here of her tattoos (and you can also check out her Instagram, for her most recent tattoos at: @sophia_mae113), and be sure to request to book with her or with any of our other talented artists, at Trip Ink Tattoo Company!',
    ],
    instagram: 'sophia_mae113',
    isPiercer: true,
  },
  {
    slug: 'casso',
    name: 'Casso',
    image: images.casso,
    roles: ['Tattoo Artist'],
    bio: [],
  },
  {
    slug: 'rich-pineda',
    name: 'Rich Pineda',
    image: images.rich,
    roles: ['Tattoo Artist'],
    bio: [],
  },
];
